























import { Global } from '@/store/globalz';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

export interface ContextMenuItem {
  icon?: string;
  disabled?: boolean;
  text: string;
  click?: () => void;
}

@Component({
  components: {},
})
export default class ContextMenu extends Vue {
  public get myStyle() {
    return {
      position: 'fixed',
      top: this.y + 'px',
      left: this.x + 'px',
    };
  }

  public items: ContextMenuItem[] = [];

  public x = 0;
  public y = 0;
  public mounted() {
    Global.contextMenu = this;
  }
  public open(event: any, items: ContextMenuItem[]) {
    this.x = event.x;
    this.y = event.y;
    this.items = items;
    (this.$refs.menu as any).show();
  }

  public onClick(item: ContextMenuItem) {
    if (item.click) {
      item.click();
    }
  }
}
